import { AbstractControl, ValidationErrors } from "@angular/forms";

export function finnishSsnValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null; // Don't validate empty values to allow optional fields
  }

  const ssn = control.value.toString().trim();

  // Finnish SSN format: DDMMYY[Century][Individual Number][Check Digit]
  // ^(\d{2})(\d{2})(\d{2})([-+A])(\d{3})([0-9A-Y])$
  // │  └─1─┘ └─2─┘ └─3─┘  └─4─┘  └─5─┘   └────6────┘
  // │    │     │     │      │      │          │
  // │    │     │     │      │      │          │
  // │    │     │     │      │      │          └─ Group 6: Check digit (0-9, A-Y excluding I, O, Q, Z)
  // │    │     │     │      │      └─ Group 5: Individual number (3 digits, 002-899)
  // │    │     │     │      └─ Group 4: Century marker (- = 1900s, + = 1800s, A = 2000s)
  // │    │     │     └─ Group 3: Year (2 digits, 00-99)
  // │    │     └─ Group 2: Month (2 digits, 01-12)
  // │    └─ Group 1: Day (2 digits, 01-31)
  // └─ Start of string
  const ssnRegex = /^(\d{2})(\d{2})(\d{2})([-+A])(\d{3})([0-9A-Y])$/;
  const match = ssn.match(ssnRegex);

  if (!match) {
    return { finnishSsn: true };
  }

  const [, day, month, year, century, individualNumber, checkDigit] = match;

  const dayNum = parseInt(day, 10);
  const monthNum = parseInt(month, 10);
  const yearNum = parseInt(year, 10);

  if (dayNum < 1 || dayNum > 31 || monthNum < 1 || monthNum > 12) {
    return { finnishSsn: true };
  }

  // Calculate and validate check digit
  const dateAndNumber = day + month + year + individualNumber;
  const remainder = parseInt(dateAndNumber, 10) % 31;
  const checkDigits = "0123456789ABCDEFHJKLMNPRSTUVWXY";
  const expectedCheckDigit = checkDigits[remainder];

  if (checkDigit !== expectedCheckDigit) {
    return { finnishSsn: true };
  }

  // Validate century marker and year combination
  const currentYear = new Date().getFullYear();
  let fullYear: number;

  switch (century) {
    case "+":
      fullYear = 1800 + yearNum;
      break;
    case "-":
      fullYear = 1900 + yearNum;
      break;
    case "A":
      fullYear = 2000 + yearNum;
      break;
    default:
      return { finnishSsn: true };
  }

  if (fullYear >= currentYear || fullYear < 1800) {
    return { finnishSsn: true };
  }

  return null;
}
